import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnDestroy, inject, input, signal, viewChild } from '@angular/core';
import { SelfServiceLoaderService, SelfServiceConfig } from '../services/selfservice-loader.service';
import { SELFSERVICE_CONFIGS } from '../config/selfservice.config';

@Component({
  selector: 'app-selfservice-host',
  templateUrl: './selfservice-host.component.html',
  styleUrls: ['./selfservice-host.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelfServiceHostComponent implements AfterViewInit, OnDestroy {
  selfServiceKey = input<string>('userRegistration');
  protected readonly mountHost = viewChild<ElementRef<HTMLElement>>('mountHost');

  protected readonly isLoading = signal(true);
  protected readonly errorMessage = signal('');
  private selfServiceConfig: SelfServiceConfig | null = null;
  private readonly selfServiceLoader = inject(SelfServiceLoaderService);

  ngAfterViewInit(): void {
    this.loadSelfService();
  }

  private async loadSelfService(): Promise<void> {
    try {
      this.isLoading.set(true);
      this.errorMessage.set('');

      const key = this.selfServiceKey();
      this.selfServiceConfig = SELFSERVICE_CONFIGS[key];
      const mountHost = this.mountHost()?.nativeElement;

      if (!this.selfServiceConfig) {
        throw new Error(`Self-service app configuration not found for key: ${key}`);
      }

      if (!mountHost) {
        throw new Error('Self-service mount host is not available.');
      }

      await this.selfServiceLoader.loadSelfService(
        this.selfServiceConfig,
        mountHost
      );

      this.isLoading.set(false);
    } catch (error) {
      this.isLoading.set(false);
      this.errorMessage.set(`Failed to load self-service app: ${error instanceof Error ? error.message : 'Unknown error'}`);
      console.error('Self-service app loading error:', error);
    }
  }

  ngOnDestroy(): void {
    if (this.selfServiceConfig) {
      this.selfServiceLoader.unloadSelfService(this.selfServiceConfig);
    }
  }
}
